module.exports = __webpack_public_path__ + "assets/img/creationMng_(34).102af3c7.png";